const tabLinks = document.querySelectorAll(".tab-link");
const tabContents = document.querySelectorAll(".tab-content-new");

tabLinks.forEach(tab => {
  tab.addEventListener("click", function (event) {
    event.preventDefault();

    let targetTab = this.getAttribute("data-tab");

    tabLinks.forEach(t => t.classList.remove("active"));
    tabContents.forEach(c => c.classList.remove("active"));

    this.classList.add("active");
    document.getElementById(targetTab).classList.add("active");
  });
});


  
const popupOverlay = document.getElementById('product-conditions-popup');
const popupContainer = document.getElementById('popup-container');
const closeBtn = document.getElementById('popup-close-button');
const triggers = document.querySelectorAll('[data-condition-popup]');

// Open popup
triggers.forEach(trigger => {
  trigger.addEventListener('click', function () {
    popupOverlay.classList.add('active');
  });
});

// Close popup on close button
closeBtn.addEventListener('click', function () {
  popupOverlay.classList.remove('active');
});

// Prevent overlay close when clicking inside popup
popupContainer.addEventListener('click', function (e) {
  e.stopPropagation();
});

// Close popup on overlay background click
popupOverlay.addEventListener('click', function () {
  popupOverlay.classList.remove('active');
});

document.querySelectorAll('.template-product [data-add-btn]').forEach(btn => {
  btn.addEventListener('click', (event) => {
    event.preventDefault();
    const targetButton = document.querySelector('.product-main-content .product-form__submit');
    if (targetButton) {
      targetButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      targetButton.click();
    }
  });
});
 

